module.exports = __webpack_public_path__ + "static/banner-bg-144f1e95c39adac2076c9e0ba87e06b4.jpg";